import { executeGetRequest, FetchConfig } from '@api/client';
import { createFetchDocClassesPath } from '@routing/apiUrls';
import { FetchDocClassesResponse } from '@models/docClasses/FetchDocClasses';

export const fetchDocClasses = async (config?: FetchConfig) => {
    const result = await executeGetRequest<FetchDocClassesResponse>(createFetchDocClassesPath(), config);
    return result.data;
};
